import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { createClient, updateClient } from "../../actions/clientActions";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "react-simple-snackbar";
const AddClient = ({
  open,
  setOpen,
  onClientAdded,
  clientTypes,
  currentId = null,
}) => {
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [clientData, setClientData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    userId: "",
    clientTypes: clientTypes || ["client"],
  });
  const user = JSON.parse(localStorage.getItem("profile"));
  const client = useSelector((state) =>
    currentId ? state.clients.clients.find((c) => c._id === currentId) : null
  );
  /*
  useEffect(() => {
    const userId = user?.result?._id || user?.result?.googleId || "";
    setClientData((prevData) => ({ ...prevData, userId }));
  }, []); // Empty dependency array
*/
  useEffect(() => {
    if (client) {
      setClientData(client);
    }
  }, [client]);

  const handleSubmitClient = async (e) => {
    e.preventDefault();

    try {
      if (currentId) {
        dispatch(updateClient(currentId, clientData, openSnackbar));
      } else {
        const newClient = await dispatch(
          createClient(clientData, openSnackbar)
        );
        if (onClientAdded) {
          onClientAdded(newClient);
        }
      }
    } catch (error) {
      console.error("Error creating client:", error);
    }

    clear();
    handleClose();
  };

  const clear = () => {
    setClientData({
      name: "",
      email: "",
      phone: "",
      address: "",
      userId: "",
      clientTypes: clientTypes || ["client"],
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setClientData({ ...clientData, [e.target.name]: e.target.value });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{t("Add New Client")}</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmitClient}>
          <TextField
            name="name"
            label={t("Name")}
            value={clientData.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            name="email"
            label={t("Email")}
            value={clientData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            name="phone"
            label={t("Phone")}
            value={clientData.phone}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            name="address"
            label={t("Address")}
            value={clientData.address}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          {/* Add other fields if necessary */}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("Cancel")}</Button>
        <Button
          onClick={handleSubmitClient}
          variant="contained"
          color="primary"
        >
          {t("Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddClient;
